import { Component, ElementRef, OnInit, ViewChild } from "@angular/core";
import { FormArray, FormBuilder, FormGroup } from "@angular/forms";
import { ActivatedRoute, Router } from "@angular/router";
import * as _ from "lodash";
import * as moment from "moment";
import { Observable } from "rxjs/Observable";
import { TAAConstants } from "../../constants/taa-constants";
import { AccommsService } from "../../services/accomms.service";
import { AppService } from "../../services/app.service";
import { LoggerService } from "../../services/audit-logger.service";
import { CommonService } from "../../services/common.service";
import { HeaderService } from "../../services/header.service";
import { PersonService } from "../../services/person.service";
import { ReasonService } from "../../services/reason.service";
import { RequestSubmitService } from "../../services/requestsubmit.service";
import { User } from "../../services/user.model";
import { StepperComponent } from "../stepper/stepper.component";

const TC3_CODES = [
  "BRAILLE",
  "BRAILLE_BOOK",
  "UNIFIED_ENG_BRAILLE",
  "READER",
  "EEO",
  "PRE_RECORDED_AUDIO",
  "TEXT2SPEECH",
  "UEB_NN_BRAILLE",
  "SCREEN_RDR",
  "VIDEO_ASL"
];

@Component({
  selector: "app-accommodations",
  templateUrl: "./accommodations.component.html",
  styleUrls: ["./accommodations.component.css"]
})
export class AccommodationsComponent implements OnInit {
  public successMessage: boolean;
  public errorMessage: boolean;
  public mandatoryMsg: boolean;
  public personName: string;
  public taaPin: string;
  public timingCodeList: any;
  public accommsError: string;
  public reconsideration: string;
  public showAccommsError: boolean;
  public publicTimingCodeError: boolean = false;
  public noOfErrors: number;
  public accommodations: any[];
  public accommodationsTimings: any[];
  public remainingAccommodations: any[];
  public remainingAccommodationsList: any[];
  public selectedRemainingAccommodation: any[];
  public approvedAccommodations: any[];
  public notApprovedAccommodations: any[];
  public incompleteAccommodations: any[];
  public isTc3InApprovedOrNonApproved: boolean;
  public currentRecord: any;
  public validationErrors: any;
  public submitStatusCd: any;
  public showContinue = false;
  public dynamicContent: any;
  public otherAccomm: any;
  public userProfile: User;
  public disableSmallGroup: boolean = false;
  public selectedOrg: any;
  frmAccomodation: FormGroup;
  formSubmitted = false;
  AccomOptions = [];
  TimingOptions = [];
  notCompatible: boolean;
  previousSelectedAccms: any;
  statusCode: any;
  tc3Code: any;
  frmAccomsError: any;
  recordCount = "0";
  @ViewChild('openModal') openModal: ElementRef;
  public auditStatusText: string = "";
  public auditLogCategory: string = "";
  public clearButton = false;
  dropdownList = [];
  public hasOtherDisability: boolean = false;
  public hasNonEllDisability: boolean = false;
  public hasOnlyELLDisability: boolean = false;

  constructor(
    public stepper: StepperComponent,
    private router: Router,
    private activatedRoute: ActivatedRoute,
    public fb: FormBuilder,
    private _commonService: CommonService,
    private accommsService: AccommsService,
    public taaConstants: TAAConstants,
    public requestSubmitService: RequestSubmitService,
    private appService: AppService,
    private _loggerService: LoggerService,
    private reasonService: ReasonService,
    private personService: PersonService,
    private headerService: HeaderService
  ) {
    this.frmAccomodation = this.fb.group({
      accommodationsCategories: this.fb.array([]),
      timing: [],
      otherAccommodationDesc: [],
      remainingAccoms: []
    });
  }

  validate = async () => {
    if (!this.frmAccomodation) {
      return;
    }
    const formData = this.frmAccomodation.value;
    const selectedAccommodations = [];
    const previousRequestedAccomms = [...this.approvedAccommodations, ...this.notApprovedAccommodations];
    let otherAccomsDescError = false;
    formData.accommodationsCategories.forEach(category => {
      category.accoms.forEach(accommodation => {
        if (accommodation.checked) {
          selectedAccommodations.push(accommodation);
        }
      });
    });
    if (this.otherAccomm) {
      const accommodation = this.otherAccomm;
      if (accommodation.ACCOMMODATION_DS === "OTHER") {
        if (!formData.otherAccommodationDesc && !this.evaluateOther(this)) {
          otherAccomsDescError = false;
        } else {
          otherAccomsDescError = !this.regexTest(
            formData.otherAccommodationDesc,
            500
          );
          accommodation.otherDesc = formData.otherAccommodationDesc;
        }
        if (formData.remainingAccoms.length > 0 && !otherAccomsDescError) {
          accommodation.checked = true;
          selectedAccommodations.push(accommodation);
        } else {
          accommodation.checked = false;
        }
      }
    }
    if (formData.timing) {
      selectedAccommodations.push(formData.timing);
    }
    if (
      selectedAccommodations.length === 0 &&
      this.statusCode !== "ReconsiderIncomplete" &&
      !this.approvedAccommodations.length &&
      !this.notApprovedAccommodations.length
    ) {
      return { requiredAccommodation: true, otherAccomsDescError: false };
    }

    if (otherAccomsDescError) {
      return { requiredAccommodation: false, otherAccomsDescError: true };
    }
    if (
      this.selectedOrg.publicCode === "Y" &&
      !this.frmAccomodation.controls.timing.value &&
      this.hasNonEllDisability
    ) {
      let timingCodeExists = false;
      if (!this.timingCodeList) {
        this.timingCodeList = await this.accommsService
          .getTimingCodeAccomms("Timing")
          .toPromise();

        this.timingCodeList.forEach(item => {
          if (formData.remainingAccoms.includes(item.ACCOMMODATION_DS)) {
            timingCodeExists = true;
          }
          if (previousRequestedAccomms.length > 0) {
            previousRequestedAccomms.forEach(previousRequestedAccommsItem => {
              if (
                previousRequestedAccommsItem.ACCOMMODATION_DS === item.ACCOMMODATION_DS
              ) {
                timingCodeExists = true;
              }
            });
          }
        });

        if (!timingCodeExists) {
          this.publicTimingCodeError = true;
          return { requiredAccommodation: true, otherAccomsDescError: false };
        }
        return null;
      } else {
        this.timingCodeList.forEach(item => {
          if (formData.remainingAccoms.includes(item.ACCOMMODATION_DS)) {
            timingCodeExists = true;
          }
          if (previousRequestedAccomms.length > 0) {
            previousRequestedAccomms.forEach(previousRequestedAccommsItem => {
              if (
                previousRequestedAccommsItem.ACCOMMODATION_DS === item.ACCOMMODATION_DS
              ) {
                timingCodeExists = true;
              }
            });
          }
        });
        if (!timingCodeExists) {
          this.publicTimingCodeError = true;
          return { requiredAccommodation: true, otherAccomsDescError: false };
        }
        return null;
      }
    } else {
      return null;
    }
  };

  regexTest(str, length) {
    if (_.isEmpty(_.toString(str))) {
      return false;
    }
    if (str.length > length) {
      return false;
    }
    const pattern = /^[a-zA-Z0-9\.\s\,\'\:\;]{1,500}$/;
    const regex = new RegExp(pattern);
    return regex.test(str);
  }

  async saveAccommodationData(proceed: boolean) {
    this.validationErrors = await this.validate();
    if (this.validationErrors) {
      this.frmAccomsError = this.validationErrors;
      return;
    }
    this.formSubmitted = true;
    const request: any = {
      requestId: this.stepper.request.requestId,
      personId: this.stepper.request.personId
    };
    const deleteSelecAccms: any = [];
    const formData = this.frmAccomodation.value;
    request.selectedAccommodations = [];
    formData.accommodationsCategories.forEach(category => {
      category.accoms.forEach(accommodation => {
        if (accommodation.checked) {
          request.selectedAccommodations.push(accommodation);
        }
      });
    });

    formData.remainingAccoms.forEach(item => {
      const acc = this.remainingAccommodationsList.find(
        a => a.ACCOMMODATION_DS === item && a.ACCOMMODATION_DS !== "OTHER"
      );

      if (acc) {
        request.selectedAccommodations.push(acc);
      }
    });

    if (this.otherAccomm) {
      const accommodation = this.otherAccomm;
      if (accommodation.ACCOMMODATION_DS === "OTHER") {
        if (!formData.otherAccommodationDesc) {
          accommodation.checked = false;
        } else {
          accommodation.otherDesc = formData.otherAccommodationDesc;
          accommodation.checked = true;
          request.selectedAccommodations.push(accommodation);
        }
      }
    }
    if (this.frmAccomodation.controls.timing.value) {
      request.selectedAccommodations.push(
        this.frmAccomodation.controls.timing.value
      );
    }

    if (
      !request.selectedAccommodations.length &&
      (this.approvedAccommodations.length ||
        this.notApprovedAccommodations.length)
    ) {
      this.saveAccomms(request, proceed);
    } else {
      this.accommsService
        .getCompatibleAccomodations(request)
        .subscribe((res: any) => {
          this.notCompatible = false;
          if (res === "false") {
            this.notCompatible = true;
          } else {
            this.saveAccomms(request, proceed);
          }
        });
    }
  }

  saveAccomms = (request, proceed) => {
    this.accommsService.saveAccommodations(request).subscribe((data: any) => {
      if (proceed) {
        if (this.statusCode === this.taaConstants.getRECONSIDER_INCOMPLETE()) {
          this.auditStatusText = "Request updated on Accommodation Page ";
          this.auditLogCategory = "REQUEST_CHANGE";
          this.updateLogs();
        }
        sessionStorage.setItem("accomSubmitted", "true");
        this.stepper.goToNextStep();
      }
      this.formSubmitted = false;
    });
  };

  goToPlan = () => {
    this.stepper.goToPrevStep();
  };
  async ngOnInit() {
    sessionStorage.setItem("planSubmitted", "");
    this.selectedOrg = this.headerService.getselectedOrgDetails();
    this.currentRecord = this.stepper.getPreviousRecordDetails();
    this.successMessage = false;
    this.errorMessage = false;
    this.mandatoryMsg = true;
    this.getStatusCode();
    this.getPersonDisability();
    Observable.forkJoin(
      this._commonService.getDynContent(
        "ON_DEFAULT_TIMING_ACCOMMODATION_CHANGED"
      ),
      this._commonService.getDynContent(
        "REQUEST_STATUS_UPDATED_TO_RECONSIDER_MSG"
      )
    ).subscribe(([accommsError, reconsideration]) => {
      this.accommsError = accommsError;
      this.reconsideration = reconsideration;
    });
    this.personName = this.currentRecord.personName;
    await this.appService
      .getUserProfile()
      .then(user => (this.userProfile = user));
    this.taaPin = this.currentRecord.taaPin;
    Observable.forkJoin([
      this.accommsService.getAccommodations(this.currentRecord.personId),
      this.accommsService.getRequestedAccommodations(
        this.currentRecord.requestId
      ),
      this.accommsService.getRequestStatusCodeForStatus("Incomplete"),
      this.accommsService.getRequestStatusCodeForStatus("Approved"),
      this.accommsService.getRequestStatusCodeForStatus("NotApproved"),
      this._commonService.getFinishedRecCount(this.currentRecord.requestId)
    ]).subscribe(
      ([
        response,
        selected,
        incomplete,
        approved,
        notApproved,
        recordCount
      ]) => {
        if (recordCount === "1") {
          this.recordCount = "1";
        } else if (recordCount === "error") {
          this.openModal.nativeElement.click();
        }
        // this.recordCount = recordCount as any;
        this.previousSelectedAccms = selected;
        const accomsArr: any[] = <Array<any>>response;
        this.accommodations = [];
        this.accommodationsTimings = [];
        this.approvedAccommodations = [];
        this.notApprovedAccommodations = [];
        this.remainingAccommodations = [];
        this.remainingAccommodationsList = [];
        this.selectedRemainingAccommodation = [];
        for (let i = 0; i < accomsArr.length; i++) {
          if (accomsArr[i]["ACCOMMODATION_CATEGORY_DS"]) {
            if (accomsArr[i]["ACCOMMODATION_CATEGORY_DS"] === "Timing") {
              accomsArr[i].ACCOMMODATION_DS.sort((a, b) => {
                return a.DISPLAY_ORDER_NO - b.DISPLAY_ORDER_NO;
              });
              accomsArr[i]["ACCOMMODATION_DS"].forEach(acc => {
                if (acc["ACCOMMODATION_CD"] === "TC3") {
                  this.tc3Code = acc;
                }
              });
              this.accommodationsTimings.push(accomsArr[i]);
            } else {
              this.accommodations.push(accomsArr[i]);
            }
          } else {
            this.remainingAccommodationsList = accomsArr[i]["ACCOMMODATION_DS"];
            accomsArr[i]["ACCOMMODATION_DS"].forEach(item => {
              const selObj = this.previousSelectedAccms.find(
                a => a.ACCOMMODATION_ID === item.ACCOMMODATION_ID
              );
              if (selObj) {
                const val = { ...item, ...selObj };
                if (
                  selObj["REQUEST_STATUS_CODE_ID"] ===
                  approved["REQUEST_STATUS_CODE_ID"] && item.ACCOMMODATION_DS !== "OTHER"
                ) {
                  this.approvedAccommodations.push(val);
                } else if (
                  selObj["REQUEST_STATUS_CODE_ID"] ===
                  notApproved["REQUEST_STATUS_CODE_ID"]
                ) {
                  this.notApprovedAccommodations.push(val);
                } else {
                  //Removing Supports from Remaining Accomms

                  if (
                    item.ACCOMMODATION_CD &&
                    !item.ACCOMMODATION_CD.toLowerCase().includes(
                      "ell_inst_"
                    ) &&
                    !item.ACCOMMODATION_CD.toLowerCase().includes("ell_w2w_") &&
                    !item.ACCOMMODATION_CD.toLowerCase().includes("ell_verbal")
                  ) {
                    this.remainingAccommodations.push(item.ACCOMMODATION_DS);
                    this.selectedRemainingAccommodation.push(
                      item.ACCOMMODATION_DS
                    );
                  }
                }
              } else {
                //Removing Supports from Remaining Accomms
                if (
                  item.ACCOMMODATION_CD &&
                  !item.ACCOMMODATION_CD.toLowerCase().includes("ell_inst_") &&
                  !item.ACCOMMODATION_CD.toLowerCase().includes("ell_w2w_") &&
                  !item.ACCOMMODATION_CD.toLowerCase().includes("ell_verbal")
                ) {
                  this.remainingAccommodations.push(item.ACCOMMODATION_DS);
                }
              }
            });
            this.remainingAccommodations.sort((a, b) =>
              a.localeCompare(b, undefined, { sensitivity: "base" })
            );
            //move OTHER selection to end of dropdown list
            const index = this.remainingAccommodations.indexOf("OTHER");
            const removed = this.remainingAccommodations.splice(index, 1);
            this.remainingAccommodations.push(removed[0]);

            this.frmAccomodation.patchValue({
              remainingAccoms: this.selectedRemainingAccommodation
            });
          }
        }
        let otherDesc;
        const catFGs = this.accommodations.map(category => {
          const accoms = (category[
            "ACCOMMODATION_DS"
          ] = this.collectApprovedOrUnApprovedAccomms(
            category,
            selected,
            approved,
            notApproved
          ));
          const accomsFGs = accoms.map(accom => {
            accom.checked = !!accom.checked;
            if (this.isSelected(accom, <any[]>selected)) {
              accom.checked = true;
            }
            return this.fb.group(accom);
          });
          return this.fb.group({
            accoms: this.fb.array(accomsFGs)
          });
        });
        this.frmAccomodation.setControl(
          "accommodationsCategories",
          this.fb.array(catFGs)
        );
        this.accommodationsTimings.forEach(category => {
          const accoms = (category[
            "ACCOMMODATION_DS"
          ] = this.collectApprovedOrUnApprovedAccomms(
            category,
            selected,
            approved,
            notApproved
          ));
          const selectedTiming = accoms.find(val =>
            this.isSelected(val, <any[]>selected)
          );
          if (selectedTiming) {
            this.frmAccomodation.patchValue({ timing: selectedTiming });
          }
          this.verifyTimingCode(selectedTiming);
        });
        if (this.otherAccomm) {
          const selectedAccom = (<any[]>selected).find(val => {
            return (
              val["ACCOMMODATION_ID"] ===
              this.otherAccomm["ACCOMMODATION_ID"] &&
              val["REQUEST_STATUS_CODE_ID"] !==
              approved["REQUEST_STATUS_CODE_ID"] &&
              val["REQUEST_STATUS_CODE_ID"] !==
              notApproved["REQUEST_STATUS_CODE_ID"]
            );
          });
          if (selectedAccom) {
            if (this.recordCount === '0' || this.statusCode === "ReconsiderIncomplete") {
              otherDesc = selectedAccom["OTHER_DS"];
              this.frmAccomodation.controls.otherAccommodationDesc.setValue(
                otherDesc
              );
              const x = document.getElementById("otherDiv");
              if (x.style.display === "none") {
                x.style.display = "block";
              }
            } else {
              const formData = this.frmAccomodation.value;
              formData.remainingAccoms[0] = false;
            }
          }
        }
      }
    );
  }
  gotoHome() {
    setTimeout(() => {
      this.router.navigate(["/examinees"]);
    }, 500);
  }

  collectApprovedOrUnApprovedAccomms(
    category,
    selected,
    approved,
    notApproved
  ): any[] {
    return category["ACCOMMODATION_DS"].filter(accomm => {
      if (accomm["ACCOMMODATION_CD"] === "OTHER") {
        this.otherAccomm = accomm;
        const selectedAccoms = (<any[]>selected).filter(
          val => val["ACCOMMODATION_ID"] === accomm["ACCOMMODATION_ID"]
        );
        selectedAccoms.forEach(selAccom => {
          const val = { ...accomm, ...selAccom };
          if (
            selAccom["REQUEST_STATUS_CODE_ID"] ===
            approved["REQUEST_STATUS_CODE_ID"]
          ) {
            this.approvedAccommodations.push(val);
          } else if (
            selAccom["REQUEST_STATUS_CODE_ID"] ===
            notApproved["REQUEST_STATUS_CODE_ID"]
          ) {
            this.notApprovedAccommodations.push(val);
          }
        });
        return false;
      }
      const selectedAccoms = (<any[]>selected).filter(
        val => val["ACCOMMODATION_ID"] === accomm["ACCOMMODATION_ID"]
      );
      var count: number = 0;
      var returnFalse: boolean = false;
      var notApprovedCheck: boolean = false;
        if (selectedAccoms) {
        selectedAccoms.forEach(selectedAccom => {
        const val = { ...accomm, ...selectedAccom };
        if (
          this.tc3Code &&
          selectedAccom["ACCOMMODATION_ID"] ===
          this.tc3Code["ACCOMMODATION_ID"] &&
          (selectedAccom["REQUEST_STATUS_CODE_ID"] ===
            approved["REQUEST_STATUS_CODE_ID"] ||
            selectedAccom["REQUEST_STATUS_CODE_ID"] ===
            notApproved["REQUEST_STATUS_CODE_ID"])&&
            (moment() < moment(selectedAccom["EXPIRATION_DT"]) || 
            selectedAccom["EXPIRATION_DT"] === null)
        ) {
          this.isTc3InApprovedOrNonApproved = true;
        }
        if (
          selectedAccom["REQUEST_STATUS_CODE_ID"] ===
          notApproved["REQUEST_STATUS_CODE_ID"]
        ) {
          this.notApprovedAccommodations.push(val);
          notApprovedCheck = true;
        }
        if (
          selectedAccom["REQUEST_STATUS_CODE_ID"] ===
          approved["REQUEST_STATUS_CODE_ID"] && 
          selectedAccom["EXPIRATION_DT"] !== null && 
          moment() < moment(selectedAccom["EXPIRATION_DT"])) {
          count++;
          this.approvedAccommodations.push(val);
        }
        else if (selectedAccom["REQUEST_STATUS_CODE_ID"] ===
        approved["REQUEST_STATUS_CODE_ID"] && (moment() > moment(selectedAccom["EXPIRATION_DT"]) ||
        selectedAccom["EXPIRATION_DT"] === null)) {
          if (selectedAccom["EXPIRATION_DT"] === null) {
          returnFalse = true;
          }
          this.approvedAccommodations.push(val);
        }
      })
      }
      if (selectedAccoms && (count >= 1 || returnFalse || notApprovedCheck)) {
        return false;
      }
      else if (selectedAccoms && count === 0) {
        return true;
      }
      return true;
    });
  }

  isSelected(accom, selected: any[]): boolean {
    return selected.find(
      val => val["ACCOMMODATION_ID"] === accom["ACCOMMODATION_ID"] && val["EXPIRATION_DT"] === null
    )
      ? true
      : false;
  }

  verifyTimingCode(item?: any) {
    const formData = this.frmAccomodation.value;
    const selectedTC3 = [];
    this.validationErrors = false;
    // if (!formData.timing || formData.timing == this.tc3Code) {
    formData.accommodationsCategories.forEach(category => {
      category.accoms.forEach(accomm => {
        if (accomm.checked && TC3_CODES.includes(accomm["ACCOMMODATION_CD"])) {
          selectedTC3.push(accomm["ACCOMMODATION_CD"]);
        }
        if (accomm["ACCOMMODATION_CD"] === "DIP") {
          if (accomm.checked) {
            this.disableSmallGroup = true;
          } else {
            this.disableSmallGroup = false;
          }
        }
      });
    });
    if (this.disableSmallGroup) {
      formData.accommodationsCategories.forEach(category => {
        category.accoms.forEach(accomm => {
          if (accomm["ACCOMMODATION_CD"] === "SMALL_GROUP") {
            accomm.checked = false;
          }
        });
      });
      const index = (((this.frmAccomodation.get(
        "accommodationsCategories"
      ) as FormArray).at(0) as FormGroup).get(
        "accoms"
      ) as FormArray).controls.findIndex(item => {
        return item.value.ACCOMMODATION_CD === "SMALL_GROUP";
      });
      ((((this.frmAccomodation.get("accommodationsCategories") as FormArray).at(
        0
      ) as FormGroup).get("accoms") as FormArray).at(index) as FormGroup)
        .get("checked")
        .patchValue(false);
      ((((this.frmAccomodation.get("accommodationsCategories") as FormArray).at(
        0
      ) as FormGroup).get("accoms") as FormArray).at(
        index
      ) as FormGroup).disable();
    } else {
      const index = (((this.frmAccomodation.get(
        "accommodationsCategories"
      ) as FormArray).at(0) as FormGroup).get(
        "accoms"
      ) as FormArray).controls.findIndex(item => {
        return item.value.ACCOMMODATION_CD === "SMALL_GROUP";
      });
      ((((this.frmAccomodation.get("accommodationsCategories") as FormArray).at(
        0
      ) as FormGroup).get("accoms") as FormArray).at(
        index
      ) as FormGroup).enable();
    }

    const val = selectedTC3.length ? this.tc3Code : undefined;
    if (item && TC3_CODES.includes(item["ACCOMMODATION_CD"])) {
      this.frmAccomodation.controls.timing.setValue("", { onlySelf: true });
    }
    if (selectedTC3.length) {
      if (!this.isTc3InApprovedOrNonApproved) {
        this.frmAccomodation.controls.timing.setValue(val, { onlySelf: true });
        this.publicTimingCodeError = false;
      }
      this.frmAccomodation.controls.timing.disable();
      this.showAccommsError = true;
    } else {
      this.frmAccomodation.controls.timing.enable();
      this.showAccommsError = false;
    }
  }
  continueToNext(proceed: boolean): void {
    Observable.forkJoin(
      this.requestSubmitService.getRequestStatusCodeIdByNm(
        this.taaConstants.getRECONSIDER_INCOMPLETE()
      )
    ).subscribe(([submitStatus]) => {
      this.submitStatusCd = submitStatus[0].REQUEST_STATUS_CODE_ID;
      const updateRequest = {
        PERSON_ID: this.currentRecord.personId,
        REQUEST_ID: this.currentRecord.requestId,
        REQUEST_STATUS_CODE_ID: this.submitStatusCd,
        REQUEST_STATE_TX: "5",
        UPDATED_BY_DS: this.currentRecord.userName
      };
      Observable.forkJoin(
        this._commonService.updateRequestForReconsider(updateRequest)
      ).subscribe(
        success => {
          if (this.recordCount !== "0") {
            this.saveAccommodationData(true);
            this.auditStatusText =
              "Request updated on Accommodation Page from Complete to ReconsiderIncomplete ";
            this.auditLogCategory = "STATUS_CHANGE";
            this.updateLogs();
          }
        },
        err => {
          console.log(err);
        }
      );
    });
  }

  getStatusCode() {
    this.accommsService
      .getRequests(this.currentRecord.requestId)
      .subscribe((data: any) => {
        this.accommsService
          .getRequestedStatusCode(data[0].REQUEST_STATUS_CODE_ID)
          .subscribe((success: any) => {
            this.statusCode = success[0].STATUS_CD;
          });
      });
  }

  updateLogs() {
    const loggerModel = {
      MODULE_ID: "REQUEST",
      CATEGORY_ID: this.auditLogCategory,
      COMPONENT_ID: "REQUEST_ACCOMMODATIONS_PAGE",
      CREATED_BY_DS: this.userProfile.userName,
      MESSAGE_TX: this.auditStatusText,
      REFERENCE_ID: this.stepper.request.personId,
      SEVERITY_VAL: "",
      UPDATED_BY_DS: this.userProfile.userName,
      USER_DATA_VAL: this.userProfile.userName
    };
    this._loggerService.updateLog(loggerModel).subscribe(
      success => { },
      err => {
        console.log(err);
      }
    );
  }
  clearTimingForm() {
    if (!this.frmAccomodation.controls.timing.disabled) {
      this.frmAccomodation.controls.timing.reset();
    }
  }

  getPersonDisability() {
    Observable.forkJoin(
      this.reasonService.getDisabilities(),
      this.personService.getPersonDisabilityById(this.stepper.request.personId)
    ).subscribe(([disabilities, response]) => {
      const disArray: any[] = <Array<any>>response;
      const disabilitiesArr: any[] = <Array<any>>disabilities;
      disArray.forEach(element => {
        const disability = disabilitiesArr.find(
          a => a.DISABILITY_CATEGORY_DS === "Other Disability"
        );
        const disArr = disability.DISABILITY_DS;
        if (disArr[0].DISABILITY_ID === element.DISABILITY_ID) {
          this.hasOtherDisability = true;
        }
      });

      disArray.forEach(e => {
        disabilitiesArr.forEach(a => {
          const selDisability = a.DISABILITY_DS.find(
            b => b.DISABILITY_ID === e.DISABILITY_ID
          );
          if (
            selDisability &&
            !selDisability.DISABILITY_NM.toString().startsWith("ELL_")
          ) {
            this.hasNonEllDisability = true;
          }
          if (selDisability) {
            this.hasOnlyELLDisability = disArray.length === 1 && selDisability.DISABILITY_NM.toString().startsWith("ELL_");
          }
        });
      });
    });
  }

  evaluateOther(obj) {
    let isOtherchecked = false;
    const formData = this.frmAccomodation.value;

    formData.remainingAccoms.forEach(item => {
      if (item === "OTHER") {
        const x = document.getElementById("otherDiv");
        if (x.style.display === "none") {
          x.style.display = "block";
        }
        isOtherchecked = true;
      }
    });
    if (!isOtherchecked) {
      const x = document.getElementById("otherDiv");
      if (x.style.display === "block") {
        x.style.display = "none";
      }

      (<HTMLInputElement>(
        document.getElementById("other_accommodations")
      )).value = "";
      this.frmAccomodation.controls.otherAccommodationDesc.setValue("");
    }
    return isOtherchecked;
  }
}



// WEBPACK FOOTER //
// ./client/views/request/accommodations/accommodations.component.ts